<template>
  <div id="app" v-bind:style="{ backgroundImage: 'url(' + this.$projectPath + '/image/bg.png' + ')' }">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App",
  components: {},
  mounted() {
    function adjustElementSize() {
      const appElement = document.getElementById('app');
      if (!appElement) return;
      const windowWidth = window.innerWidth;

      const baseWidth = 1980;

      const widthRatio = windowWidth / baseWidth;

      if (widthRatio > 1) {
        appElement.style.zoom = widthRatio * 0.96;
      } else {
        appElement.style.zoom = widthRatio * 1.15;
      }
    }

    // 监听窗口大小变化事件
    window.addEventListener('resize', adjustElementSize);

    // 初始调用以设置初始尺寸
    adjustElementSize();
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

::-webkit-scrollbar {
  width: 5px;
  background: #fff;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #aaa;
}

html,
body {
  height: 100%;
  width: 100%;
  font-size: 14px;
  background-color: #f0f5ff;
  font-family: Microsoft YaHei;
}

#app {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: url("~@img/bg.png") no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
}
</style>
